// extracted by mini-css-extract-plugin
export default {"label":"useBusinessWalkInReg_label__xlZJs","desc":"useBusinessWalkInReg_desc__jyuhc"};